module.exports = __webpack_public_path__ + "img/signal_wifi_1_bar-red.64917af9.svg";